import * as React from 'react';
import { NewbuildingCarousel, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import { SLIDER_FIRST_PAINT, SLIDER_MEDIA } from './constants';

export interface IGalleryCarouselProps {
  onSlideChange?(currentSlide: number, prevSlide: number): void;
  slideIndex: number;
  slides: React.ReactNode[];
}

export const GalleryCarousel: React.VFC<IGalleryCarouselProps> = ({ onSlideChange, slideIndex, slides }) => {
  const currentSlide = slideIndex + 1;

  const handleSlideChange = React.useCallback(
    (params: TOnSlideChangeParams) => {
      if (onSlideChange) {
        onSlideChange(params.currentSlide - 1, params.prevSlide - 1);
      }
    },
    [onSlideChange],
  );

  return (
    <NewbuildingCarousel
      slides={slides}
      firstPaintOptions={SLIDER_FIRST_PAINT}
      media={SLIDER_MEDIA}
      onSlideChange={handleSlideChange}
      defaultCurrentSlide={currentSlide}
    />
  );
};
